import { gql } from 'graphql-request';

import { parseAssets } from 'lib/parseData';
import { Asset } from './fragments';
import graphQLClient, { OrOperationType } from '.';

type ParamsType = {
  count: number;
  from: number;
  sortBy?: string;
  sortAscending?: boolean;
  orOperations?: OrOperationType[] | OrOperationType[][];
  andOperations?: { key: string; value: string }[];
};

const GET_MY_ITEMS = gql`
  ${Asset}
  query GetAssets(
    $count: Int!
    $from: Int!
    $orOperations: [[MatchFilter]]
    $andOperations: [MatchFilter]
    $rangeFilters: [RangeFilter]
    $sortBy: SortBy
    $sortAscending: Boolean
    $fieldKeysForGroupBy: [String]
    $fieldKeysForRange: [String]
  ) {
    asset(
      count: $count
      from: $from
      orOperations: $orOperations
      andOperations: $andOperations
      rangeFilters: $rangeFilters
      sortBy: $sortBy
      sortAscending: $sortAscending
      fieldKeysForGroupBy: $fieldKeysForGroupBy
      fieldKeysForRange: $fieldKeysForRange
    ) {
      total
      groupByFieldKey
      rangeByFieldKey
      assets {
        ...Asset
      }
    }
  }
`;

const getMyItemsData = async (params: ParamsType) => {
  const data = await graphQLClient.request(GET_MY_ITEMS, params);
  const {
    asset: { total, assets },
  } = data;
  const assetList = parseAssets(assets);

  return {
    total,
    assets: assetList,
  };
};

export default getMyItemsData;
